export const getAccessToken = (key: string) => {
  return localStorage.getItem(key);
};
